import { render, staticRenderFns } from "./MailLogsPage.vue?vue&type=template&id=6e650ab3&scoped=true&"
import script from "./MailLogsPage.vue?vue&type=script&lang=js&"
export * from "./MailLogsPage.vue?vue&type=script&lang=js&"
import style0 from "./MailLogsPage.vue?vue&type=style&index=0&id=6e650ab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e650ab3",
  null
  
)

export default component.exports